const map = [
  { event: 'bounds_changed', emit: 'bounds-changed' },
  { event: 'center_changed', emit: 'center-changed' },
  { event: 'click', emit: 'click' },
  { event: 'dblclick', emit: 'double-click' },
  { event: 'drag', emit: 'drag' },
  { event: 'dragend', emit: 'drag-end' },
  { event: 'dragstart', emit: 'drag-start' },
  { event: 'heading_changed', emit: 'heading-changed' },
  { event: 'idle', emit: 'idle' },
  { event: 'maptypeid_changed', emit: 'map-type-id-changed' },
  { event: 'mousemove', emit: 'mouse-move' },
  { event: 'mouseout', emit: 'mouse-out' },
  { event: 'mouseover', emit: 'mouse-over' },
  { event: 'projection_changed', emit: 'projection-changed' },
  { event: 'resize', emit: 'resize' },
  { event: 'rightclick', emit: 'right-click' },
  { event: 'tilesloaded', emit: 'tiles-loaded' },
  { event: 'tilt_changed', emit: 'tilt-changed' },
  { event: 'zoom_changed', emit: 'zoom-changed' }
]

export default map